export default "__VITE_ASSET__9a3dea82__"